'use client'

import { useEffect, useState } from "react"
import apiService from "../services/apiService"
import UserReservationsSection from "./UserReservationsSection"
import { FormData } from "@/types/type"

export default function MyReservations({ userId }: { userId: string | null }) {
  const [reservations, setReservations] = useState<any[]>([])
  const [user, setUser] = useState<Partial<FormData>>({});

  const refreshUserData = async () => {
    try {
      const response = await apiService.get('/api/auth/user/');
      setUser(response);
    } catch (err) {
      console.error('Erro ao buscar dados do usuário:', err);
    }
  };

  useEffect(() => {
    if (!userId) return

    const fetchReservations = async () => {
      try {
        const response = await apiService.get('/api/auth/myreservations/')
        setReservations(response)
      } catch (err) {
        console.error("Erro ao buscar reservas:", err)
      }
    }

    fetchReservations()
    refreshUserData();
  }, [userId])

    if (!userId) {
    return (
      <main className="max-w-[1500px] min-h-screen max-auto px-6 py-12 p-6 ml-0 md:ml-64">
        <p>🔐🔑 Você precisa de um login.......................🏳‍🌈</p>
      </main>
    )
  }

  return (
    <div className="min-h-screen max-w-[1500px] mx-auto px-6 pb-6 p-6">
      <h1
        className="my-6 mb-6 text-2xl text-center">
          Minhas reservas
      </h1>      
      <div className="space-y-4">
        <UserReservationsSection
          reservations={reservations}
          user={user}
          refreshUserData={refreshUserData}
        />
      </div>
    </div>
  )
}
